module.exports = __webpack_public_path__ + "img/04.083bec53.png";